import { SearchOutlined } from '@mui/icons-material';
import { OutlinedInput, OutlinedInputProps } from '@mui/material';
import React, { useCallback } from 'react';

interface ISearchInputProps extends Omit<OutlinedInputProps, 'startAdornment'> {
	onSearchChange?: (newValue: string) => any;
}

const SearchInput: React.FC<ISearchInputProps> = ({
	placeholder = intl.tr('general.search'),
	onSearchChange = null,
	onChange,
	...rest
}) => {
	const onChangeHandler = useCallback<
		Exclude<OutlinedInputProps['onChange'], undefined>
	>(
		(e) => {
			onChange?.(e);
			onSearchChange?.(e.target.value);
		},
		[onChange, onSearchChange]
	);

	return (
		<OutlinedInput
			{...rest}
			onChange={onChangeHandler}
			startAdornment={<SearchOutlined color="action" sx={{ mr: 1 }} />}
			placeholder={placeholder}
		/>
	);
};

export default SearchInput;
